import { loadingSubject } from './loading-container';

let id = 0;

const handleDisableEnterSubmit = (e) => {
  if (e.keyCode === 13 || e.which === 13) {
    e.preventDefault();

    return false;
  }
};

export function addLoading() {
  const loadings = [...loadingSubject.getValue()];

  document.addEventListener('keypress', handleDisableEnterSubmit);

  const newIndex = id++;

  loadings.push(newIndex);

  loadingSubject.next(loadings);
}

export function removeLoading() {
  const loadings = [...loadingSubject.getValue()];

  loadings.length && loadings.pop();

  !loadings.length && document.removeEventListener('keypress', handleDisableEnterSubmit);

  loadingSubject.next(loadings);
}

export function removeAllLoading() {
  document.removeEventListener('keypress', handleDisableEnterSubmit);
  loadingSubject.next([]);
}
